import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

import CenteredCircularProgress from '../../lib/designSystem/CircularProgress';
import EnhancedTab from '../../lib/designSystem/TabSimulation';
import { setInitialTab } from '../../lib/functions/setInitialTab';
import {
  hasAnyPermissions,
  validateCompanyTypes,
  validatePermissions,
} from '../../lib/functions/utils';
import {
  hasAnyAccountingPermission,
  hasAnyCollectionsPermission,
  hasAnyFinancingTabPermission,
  hasAnyPaymentPermission,
  hasAnyReportingPermission,
} from '../../lib/permissionChecks';
import { AuthState } from '../../services/redux/authSlice';
import Accounting from './Components/Accounting';
import Collection from './Components/Collection';
import Financing from './Components/Financing';
import Funds from './Components/Funds';
import Payments from './Components/Payments';
import Reporting from './Components/Reporting';
import FinanceSII from './Components/SII';

const Finance: React.FC = () => {
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);

  const companyTabs: any = [];
  if (hasAnyFinancingTabPermission(user))
    companyTabs.push({
      label: 'Financiamiento',
      component: <Financing />,
      mainPage: 'financing',
      index: 1,
    });
  if (validatePermissions(user, 'financing_fundSale_view'))
    companyTabs.push({
      label: 'Fondos',
      component: <Funds />,
      mainPage: 'funds',
      subPage: 'summary',
    });
  if (hasAnyPaymentPermission(user))
    companyTabs.push({
      label: 'Pagos',
      component: <Payments />,
      mainPage: 'payments',
      subPage: 'out',
      index: 3,
    });
  if (hasAnyCollectionsPermission(user))
    companyTabs.push({
      label: 'Cobranza',
      component: <Collection />,
      mainPage: 'collections',
      subPage: 'home',
      index: 4,
    });
  if (hasAnyReportingPermission(user))
    companyTabs.push({
      label: 'Reportes',
      component: <Reporting />,
      mainPage: 'reporting',
      subPage: 'activeMoney',
      index: 5,
    });
  if (hasAnyAccountingPermission(user))
    companyTabs.push({
      label: 'Contabilidad',
      component: <Accounting />,
      mainPage: 'accounting',
      subPage: 'dailyBook',
      index: 6,
    });
  // if (validatePermissions(user, 'invoices_confirm_reject'))
  //   companyTabs.push({
  //     label: 'Proveedores',
  //     component: <Suppliers />,
  //     mainPage: 'suppliers',
  //   });

  const theBiller = {
    label: 'SII',
    component: <FinanceSII />,
    mainPage: 'sii',
    subPage: 'invoicing',
    index: 5,
  };

  const { mainPage } = useParams<{ page: string; mainPage: string }>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [compnayTabs, setCompanyTabs] = useState<any>(companyTabs);
  const [startValue, setStartValue] = useState(0);

  const handleNavigation = (index: number) => {
    navigate(
      `/finance/${compnayTabs[index].mainPage}/${compnayTabs[index].subPage}`,
    );
  };

  const setTabs = async () => {
    setLoading(true);
    const newCompanyTabs: any = [];
    const canAccessToAllTabs = validateCompanyTypes(user, 'FinancingHub');

    if (canAccessToAllTabs) {
      newCompanyTabs.push(...companyTabs);
    } else {
      const factoringQuoteAvailable = validateCompanyTypes(
        user,
        'FactoringQuoting',
      );
      if (factoringQuoteAvailable) {
        newCompanyTabs.push(companyTabs[0]);
      }
      if (validateCompanyTypes(user, 'AccountantCollections')) {
        newCompanyTabs.push(companyTabs[1], companyTabs[2]);
      }
    }

    if (validateCompanyTypes(user, 'SII_Biller')) {
      newCompanyTabs.push(theBiller);
    }
    setInitialTab(
      setCompanyTabs,
      setStartValue,
      mainPage,
      newCompanyTabs,
      'finance',
    );
    setLoading(false);
  };

  useEffect(() => {
    setTabs();
  }, []);

  if (loading) return <CenteredCircularProgress type="layout" />;

  return (
    <div>
      <EnhancedTab
        title="Finanzas"
        startValue={startValue}
        tabs={compnayTabs}
        onTabChange={handleNavigation}
      />
    </div>
  );
};

export default Finance;
